// Making a new JS component
// 1 - Replace awards with new name ( 8 occurences in this file )
// 2 - All code goes into init()
// 3 - Save file as new name .js
var awards = {
	name: 'awards',
	componentInitSelector: '.awards',
	registerComponent: function() {
		if ( $(awards.componentInitSelector).length ) {
			framework.registerComponent(awards);
		}
	},
	initAwards: function() {
        // Put your args and inits here with their options.

        // End
        log(config.application.name + " •• awards in " + Math.round( performance.now() - framework.initComponents.componentInitTime) + " milliseconds" );
    },
	init: function() {
		// All code for this component goes in here

			  // Get an array of all element heights
			  var elementHeights = $('.card-award p.awardTitle').map(function() {
			    return $(this).height();
			  }).get();

			  // Math.max takes a variable number of arguments
			  // `apply` is equivalent to passing each height as an argument
			  var maxHeight = Math.max.apply(null, elementHeights);

			  // Set each height to the max height
			  $('.card-award p.awardTitle').height(maxHeight);


		// End
		awards.initAwards();
	}
}

// Register self to the framework
awards.registerComponent();